import { Component } from '@angular/core';
import { LineChartComponent } from "../../components/charts/line-chart.component";
import { dashboard_transactions } from '../../providers/dummy-data';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [LineChartComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {

  data = dashboard_transactions

}
